import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthSessionService } from '../services/auth-session.service';
import { getPostLoginRoute } from '../constants/admin-access.constants';
import { isMobileOtpAuthPath } from 'src/app/mobile-auth/shared/mobile-webview-session';

/**
 * Guest-only guard for public auth pages (login, register, forgot-password, …).
 * Signed-in users are sent to their role home.
 *
 * `/signin` and `/signup` are the mobile OTP webview. A leftover Firebase
 * session in Capacitor Browser must not bounce those pages to /aunak-pro-app
 * or the admin dashboard.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private session: AuthSessionService,
    private router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.session.ready().pipe(
      map((profile) => {
        if (!profile || isMobileOtpAuthPath(state.url)) {
          return true;
        }
        return this.router.createUrlTree([
          getPostLoginRoute(profile.role, profile.isApproved),
        ]);
      }),
    );
  }
}
